var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSwapHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.81849 3.02212C6.01462 2.82773 6.01604 2.51115 5.82165 2.31502C5.62726 2.11889 5.31068 2.11748 5.11455 2.31186L4.15378 3.26409C3.79633 3.61835 3.49821 3.91381 3.28565 4.17849C3.0627 4.4561 2.89311 4.74787 2.84781 5.10333C2.79252 5.53707 3.15223 5.83366 3.50081 5.83366H12.6666C12.9427 5.83366 13.1666 5.6098 13.1666 5.33366C13.1666 5.05752 12.9427 4.83366 12.6666 4.83366H4.04238C4.04977 4.82418 4.05742 4.81451 4.06534 4.80465C4.23807 4.58957 4.49497 4.33388 4.87824 3.95402L5.81849 3.02212Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 10.167C3.05711 10.167 2.83325 10.3908 2.83325 10.667C2.83325 10.9431 3.05711 11.167 3.33325 11.167H12.091C12.0836 11.1765 12.0759 11.1861 12.068 11.196C11.8953 11.4111 11.6384 11.6668 11.2551 12.0466L10.3148 12.9785C10.1187 13.1729 10.1173 13.4895 10.3117 13.6856C10.5061 13.8818 10.8227 13.8832 11.0188 13.6888L11.9795 12.7366C12.337 12.3823 12.6351 12.0868 12.8477 11.8222C13.0706 11.5445 13.2402 11.2528 13.2855 10.8973C13.2875 10.8818 13.2893 10.8663 13.2909 10.8508C13.3316 10.4489 13.0012 10.167 12.6666 10.167H3.33325Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSwapHorizontal);
export default __webpack_public_path__ + "static/media/ArrowSwapHorizontal.9379fb5486a1d2eab9d3c69a6326e876.svg";
export { ForwardRef as ReactComponent };